  (function() {
    'use strict';

    /* ---- Countdown Timer ---- */
    function updateCountdown() {
      var now = new Date();
      var midnight = new Date(now);
      midnight.setHours(23, 59, 59, 999);
      var diff = midnight.getTime() - now.getTime();
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var hEl = document.getElementById('countdown-h');
      var mEl = document.getElementById('countdown-m');
      var sEl = document.getElementById('countdown-s');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);

    /* ---- Hero Carousel ---- */
    var slides = document.querySelectorAll('.hero-carousel__slide');
    var dots = document.querySelectorAll('.hero-carousel__dot');
    var thumbs = document.querySelectorAll('.hero-carousel__thumb');
    var currentSlide = 0;
    var slideCount = slides.length;

    function goToSlide(index) {
      slides.forEach(function(s) { s.classList.remove('active'); });
      dots.forEach(function(d) { d.classList.remove('active'); });
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      currentSlide = index;
      if (slides[currentSlide]) slides[currentSlide].classList.add('active');
      if (dots[currentSlide]) dots[currentSlide].classList.add('active');
      if (thumbs[currentSlide]) thumbs[currentSlide].classList.add('active');
    }

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { goToSlide(i); });
    });
    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { goToSlide(i); });
    });

    /* Auto-scroll removed – user clicks through manually */

    /* ---- Plan Selection ---- */
    var plan90 = document.getElementById('plan-90');
    var plan30 = document.getElementById('plan-30');
    var perks90 = document.getElementById('perks-90');
    var ctaPrice = document.getElementById('cta-price');
    var ctaSuffix = document.getElementById('cta-suffix');

    function selectPlan(selectedEl, otherEl) {
      if (!selectedEl || !otherEl) return;
      selectedEl.classList.add('selected');
      otherEl.classList.remove('selected');
      var radio1 = selectedEl.querySelector('.hero__option-radio');
      var radio2 = otherEl.querySelector('.hero__option-radio');
      if (radio1) radio1.classList.add('active');
      if (radio2) radio2.classList.remove('active');
      var price = selectedEl.getAttribute('data-price');
      var suffix = selectedEl.getAttribute('data-suffix');
      if (ctaPrice) ctaPrice.textContent = price;
      if (ctaSuffix) ctaSuffix.textContent = suffix;
      if (perks90) {
        perks90.style.display = (selectedEl === plan90) ? 'block' : 'none';
      }
    }

    if (plan90) {
      plan90.addEventListener('click', function() { selectPlan(plan90, plan30); });
    }
    if (plan30) {
      plan30.addEventListener('click', function() { selectPlan(plan30, plan90); });
    }

    /* ---- FAQ Accordion ---- */
    document.querySelectorAll('[data-faq-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = trigger.closest('[data-faq-item]') || trigger.closest('.faq__item');
        if (!item) return;
        var wasOpen = item.classList.contains('open');
        document.querySelectorAll('.faq__item.open').forEach(function(el) {
          el.classList.remove('open');
        });
        if (!wasOpen) {
          item.classList.add('open');
        }
      });
    });

    /* ---- Hero Dropdowns ---- */
    document.querySelectorAll('[data-hero-dropdown]').forEach(function(dropdown) {
      var trigger = dropdown.querySelector('.hero__dropdown-trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function() {
        var wasOpen = dropdown.classList.contains('open');
        document.querySelectorAll('[data-hero-dropdown]').forEach(function(d) {
          d.classList.remove('open');
          var icon = d.querySelector('.hero__dropdown-icon');
          if (icon) icon.textContent = '+';
        });
        if (!wasOpen) {
          dropdown.classList.add('open');
          var icon = dropdown.querySelector('.hero__dropdown-icon');
          if (icon) icon.textContent = '\u2212';
        }
      });
    });

    /* ---- Sticky Bar + Offer Bar (scroll) ---- */
    var stickyBar = document.getElementById('sticky-bar');
    var offerBar = document.getElementById('offer-bar');

    window.addEventListener('scroll', function() {
      var scrollY = window.scrollY || window.pageYOffset;
      if (stickyBar) {
        if (scrollY > 400) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      }
      if (offerBar) {
        if (scrollY > 400) {
          offerBar.classList.add('visible');
        } else {
          offerBar.classList.remove('visible');
        }
      }
    });

    /* ---- Scroll Animations ---- */
    var animateEls = document.querySelectorAll('.animate-in');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.06, rootMargin: '0px 0px -50px 0px' });
      animateEls.forEach(function(el) { observer.observe(el); });
    } else {
      animateEls.forEach(function(el) { el.classList.add('visible'); });
    }

    /* ---- Body Support Tabs ---- */
    document.querySelectorAll('[data-bs-tab]').forEach(function(pill) {
      pill.addEventListener('click', function() {
        var idx = pill.getAttribute('data-bs-tab');
        document.querySelectorAll('[data-bs-tab]').forEach(function(p) { p.classList.remove('active'); });
        pill.classList.add('active');
        document.querySelectorAll('[data-bs-panel]').forEach(function(panel) {
          panel.style.display = (panel.getAttribute('data-bs-panel') === idx) ? 'block' : 'none';
        });
      });
    });

    /* ---- CountUp Animation ---- */
    var countUpEls = document.querySelectorAll('[data-countup]');
    if ('IntersectionObserver' in window && countUpEls.length > 0) {
      var countObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var target = parseInt(el.getAttribute('data-countup'), 10);
            var suffix = el.getAttribute('data-suffix') || '';
            var duration = 2000;
            var startTime = performance.now();

            function animate(now) {
              var elapsed = now - startTime;
              var progress = Math.min(elapsed / duration, 1);
              var eased = 1 - Math.pow(1 - progress, 3);
              el.textContent = Math.round(eased * target) + suffix;
              if (progress < 1) {
                requestAnimationFrame(animate);
              }
            }
            requestAnimationFrame(animate);
            countObserver.unobserve(el);
          }
        });
      }, { threshold: 0.5 });
      countUpEls.forEach(function(el) { countObserver.observe(el); });
    }

    /* ---- Video Modal ---- */
    var videoModal = document.getElementById('videoModal');
    var videoModalClose = document.getElementById('videoModalClose');
    var videoModalImg = document.getElementById('videoModalImg');
    var videoModalName = document.getElementById('videoModalName');
    var videoModalTitle = document.getElementById('videoModalTitle');
    if (videoModal) {
      document.querySelectorAll('.video-card').forEach(function(card) {
        card.addEventListener('click', function() {
          var img = card.querySelector('.video-card__thumb img');
          var name = card.querySelector('.video-card__name');
          var title = card.querySelector('.video-card__title');
          if (videoModalImg && img) videoModalImg.src = img.src;
          if (videoModalName && name) videoModalName.textContent = name.textContent;
          if (videoModalTitle && title) videoModalTitle.textContent = title.textContent;
          videoModal.style.display = 'flex';
        });
      });
      videoModal.addEventListener('click', function(e) {
        if (e.target === videoModal) videoModal.style.display = 'none';
      });
      if (videoModalClose) {
        videoModalClose.addEventListener('click', function() { videoModal.style.display = 'none'; });
      }
    }

    /* ---- Touch Swipe for Carousel ---- */
    var carouselTrack = document.querySelector('.hero-carousel__track');
    if (carouselTrack) {
      var touchStartX = 0, touchStartY = 0;
      carouselTrack.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY; }, {passive:true});
      carouselTrack.addEventListener('touchend', function(e) {
        var diffX = e.changedTouches[0].clientX - touchStartX;
        var diffY = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(diffX) < 40 || Math.abs(diffX) < Math.abs(diffY)) return;
        if (diffX < 0 && currentSlide < slideCount - 1) goToSlide(currentSlide + 1);
        else if (diffX > 0 && currentSlide > 0) goToSlide(currentSlide - 1);
      }, {passive:true});
    }

  })();
